import React, { Suspense, useCallback, useEffect, useState } from 'react'
import AutomationsGrid from '../../../GridList/AutomationsGrid'
import CreateAutomation from './EditAutomations/CreateAutomation';
import Card from "../../../GridList/Card";
import CreateRule from './CreateRule/CreateRule';
import RuleWizard from './RuleWizard/RuleWizard';
import ScheduledAction from './EditAutomations/ScheduledAction';
import CreateSchedule from './EditAutomations/CreateSchedule';
import { getAdvRules, getHolidaysModesAPI, getInputRules, getSchedules, getSiteAccessRestrictions } from '../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import { Await } from 'react-router-dom';
import Oval from 'react-loading-icons/dist/esm/components/oval';
import RuleCardSkeleton from '../Rules/RuleCardSkeleton';

import classes from "./Automations.module.css"
import { VerifyHandler } from '../../../../store/auth-actions';
import CreateHolidayMode from './HolidayMode/CreateHolidayMode';
import CreateAccessRestriction from './CreateAccessRestriction/CreateAccessRestriction';
import useData from 'rsuite/esm/InputPicker/hooks/useData';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import { Button } from 'primereact/button';
import successAnim from '../../../../assets/animations/success.json'
import failAnim from '../../../../assets/animations/fail.json'

const Automations = ({ outputs, inputs, deviceData, firmware, siteType, onRulesChanged}) => {
    const numInput = deviceData.singleDeviceSettingData.numInput
    const smartLocks = deviceData.singleDeviceSettingData.iglooLocks;
    const [IFTTTRules, setIFTTTRules] = useState(null);
    const [advRules, setAdvRules] = useState(null);
    const [schedules, setSchedules] = useState(null);
    const [holidaymode, setHolidayMode] = useState(null);
    const [siteAccessRestrictions, setSiteAccessRestrictions] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    const [failMessage, setFailMessage] = useState("")

    const [successVisible, setSuccessVisible] = useState(false);
    const [failVisible, setFailVisible] = useState(false);

    let token = useSelector(state => state.auth.token);
    let client = useSelector(state => state.auth.client);
    let DeviceUUID = useSelector(state => state.auth.DeviceUUID);


    const apiData = {
        token,
        client
    }

    // fetchAutomations is called when an automation is Created, Edited or Deleted.
    const fetchAutomations = async () => {
        setIsLoading(true);

        const [ifTTTRules, advRulesRes, schedulesRes, holidayModesRes, accessRestrictionsRes] = await Promise.all([
            getInputRules(apiData, DeviceUUID),
            getAdvRules(apiData, DeviceUUID, dispatch),
            getSchedules(apiData, DeviceUUID),
            getHolidaysModesAPI(apiData, DeviceUUID),
            getSiteAccessRestrictions(DeviceUUID, apiData, dispatch),
        ]);

        setIFTTTRules(ifTTTRules);
        setAdvRules(advRulesRes.success ? advRulesRes.data.rules : []);
        console.log(advRulesRes.data.rules);
        setSchedules(schedulesRes.data);
        setHolidayMode(holidayModesRes);
        setSiteAccessRestrictions(accessRestrictionsRes);
        setIsLoading(false);
        onRulesChanged?.()
    }

    // Fetch data on mount
    useEffect(() => {
        fetchAutomations();
    }, []);


    const [showAutomation, setShowAutomation] = useState(null);
    //user selects between creating a sheduledAction, reminder or a rule - 0,1 or 2
    const HandleSelectAutomation = (AutomationID) => {
        
        setShowAutomation(AutomationID);
    }

    //--------------------   first index is outputs, second index is inputs, third is device details--------------------------------
    const DeviceDataArray = Object.values(deviceData);

    let allListOptionsArray;

    if (numInput != 0) {
        allListOptionsArray = [...outputs, ...inputs];
    } else {
        allListOptionsArray = [...outputs];
    }

    //--------------------------------------------------------------------------------------------------------------------------------

    //use to pass the rule's pins that haven't been assigned to CreateRule component
    const [remainingrules, setRemainRules] = useState([]);

    const updateRemainRules = (rules) => {
        setRemainRules(rules)
    }

    return (
        <>

        <Dialog
                header="Success"
                visible={successVisible}
                style={{ width: "40vw" }}
                onHide={() => setSuccessVisible(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Rule created successfully!</h3>
                        <Lottie
                            animationData={successAnim}
                            loop={false}
                            style={{ width: 250, height: 250, margin: "0px" }}
                        />

                    <Button label="Close & refresh" icon="pi pi-times" severity="primary" onClick={() => {setSuccessVisible(false); fetchAutomations();}}/>
                </div>
            </Dialog>

            <Dialog
                header="Error"
                visible={failVisible}
                style={{ width: "40vw" }}
                onHide={() => setFailVisible(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Lottie
                            animationData={failAnim}
                            loop={false}
                            style={{ width: 150, height: 150, margin: "0px" }}
                        />
                        <h3 style={{color:"#6e6e6eff"}}>{failMessage}</h3>
                    <Button label="Close" icon="pi pi-times" severity="primary" onClick={() => setFailVisible(false)}/>
                </div>
            </Dialog>
        
        <div>
            {isLoading ? (
                <div className={classes["skeleton-grid"]}>
                    {[...Array(20)].map((_, i) => <RuleCardSkeleton key={i} />)}
                </div>
            ) : (
                <AutomationsGrid
                    DeviceRules={IFTTTRules}
                    siteSchedules={schedules}
                    siteHolidayModes={holidaymode}
                    outputs={outputs}
                    inputs={inputs}
                    allListOptionsArray={allListOptionsArray}
                    HandleSelectAutomation={HandleSelectAutomation}
                    fetchAutomations={fetchAutomations}
                    numInput={numInput}
                    smartLocks={smartLocks}
                    updateRemainRules={updateRemainRules}
                    siteAccessRestrictions={siteAccessRestrictions}
                    advRules={advRules}
                />
            )}
            
            {showAutomation == 5 && <RuleWizard allListOptionsArray={remainingrules || allListOptionsArray} firmware={firmware} smartLocks={smartLocks} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} />}

            {showAutomation == 2 && <CreateRule allListOptionsArray={remainingrules || allListOptionsArray} OutPutsPinNames={outputs} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} firmware={firmware} smartLocks={smartLocks} setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} siteType={siteType} />}
            {(showAutomation == 0 || showAutomation == 1) && < CreateSchedule OutPutOptions={outputs} isReminder={showAutomation} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} />}

            {showAutomation === 3 && <CreateHolidayMode OutPutsPinNames={outputs} setShowAutomation={setShowAutomation} smartLocks={smartLocks} fetchAutomations={fetchAutomations} />}
            {showAutomation === 4 && <CreateAccessRestriction fetchAutomations={fetchAutomations} setShowAutomation={setShowAutomation}/>}
        </div>
        </>
    )
}

export default React.memo(Automations);
